import { ColStack } from 'components/atoms/container/InCardStack'
import AddRatersDescriptions from 'components/molecules/assessments/AddRatersDescriptions'
import AddRatersCard from './AddRatersCard'
const AddRaterPageCard = ({
  fromSelfAssessment,
  goalId,
  assessmentData,
  containerProps = {},
  addRatersProps = {}
}) => {
  return (
    <ColStack
      paddingTop={16}
      spacing={16}
      data-testid='add-raters-card'
      {...containerProps}>
      <AddRatersDescriptions />
      <AddRatersCard
        fromSelfAssessment={fromSelfAssessment}
        goalId={parseInt(goalId, 10)}
        data={assessmentData}
        {...addRatersProps}
      />
    </ColStack>
  )
}

export default AddRaterPageCard
